import React from 'react';
import classNames from 'classnames';

const RegisterGuestResponse = () => {
  return (
    <div
      className={classNames({
        container: true,
        'w-full': true,
        'max-w-xs': true,
        'mx-auto': true,
        'bg-green-gradient': true,
      })}
    >
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <br />
        <h1 className="rejectionTitle text-center mt-4" style={{ color: '#fff' }}>
          {'Success!'}
        </h1>
        <br />
        <p className="text-center text-white successText" style={{ fontSize: '14px' }}>
          Thank you for registration. You will receive an email shortly to complete your registration.
        </p>
      </div>
    </div>
  );
};
export default RegisterGuestResponse;
